import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import RecipeApiClient from "../../api/RecipeApiClient";

const recipeClient = new RecipeApiClient();

export default function RecipeCreatorWidget() {
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleCreate = async () => {
    if (!description.trim()) {
      setError("Please enter a recipe description");
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const recipe = await recipeClient.createRecipe(description);
      setSuccess(`Recipe created: ${recipe.title}`);
      setDescription("");
    } catch (err: any) {
      setError(err.response?.data || "Failed to create recipe");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Create Recipe
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Enter a short description and AI will generate a complete recipe
      </Typography>

      <TextField
        fullWidth
        multiline
        rows={3}
        placeholder='e.g., "Overnight oats with greek yogurt" or "Perfectly grilled cheeseburgers"'
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        disabled={loading}
        sx={{ mb: 2 }}
      />

      <Button
        variant="contained"
        onClick={handleCreate}
        disabled={loading || !description.trim()}
        fullWidth
      >
        {loading ? <CircularProgress size={24} /> : "Generate Recipe"}
      </Button>

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mt: 2 }}>
          {success}
        </Alert>
      )}
    </Paper>
  );
}
